import fetchV2 from "auth/FetchInterceptorV2";
import { env } from "configs/EnvironmentConfig";

const allocateCollectorService = {};

// List Allocate Collector
allocateCollectorService.listAllocateCollector = ({
  params,
  is_odd_week = false,
}) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [
    "id",
    "mon",
    "tue",
    "wed",
    "thu",
    "fri",
    "sat",
    "sun",
    "hub_id",
  ];

  return fetchV2({
    url: `${env.API_MSP}/collector/collector-schedules/schedule`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      keywords: params.keywords || "",
      expand: params.expand || "route,timeSlot",
      fields: params.fields || defaultFields.join(","),
    },
  });
};

allocateCollectorService.listChangeScheduleByCollector = ({ params }) => {
  const columnFilter = params.columnFilter || {};

  const defaultFields = [];

  return fetchV2({
    url: `${env.API_MSP}/collector/collector-schedule-changes`,
    method: "get",
    params: {
      ...columnFilter,
      page: params.page || 1,
      "per-page": params.sizePerPage || 10,
      keywords: params.keywords || "",
      expand: params.expand || "",
      fields: params.fields || defaultFields.join(","),
      sort: params.sort,
      "filter[record_status]": "O",
    },
  });
};

// createCollectorScheduleChanges
allocateCollectorService.createCollectorScheduleChanges = data => {
  return fetchV2({
    url: `${env.API_MSP}/collector/collector-schedule-changes`,
    method: "post",
    data,
  });
};

// updateCollectorScheduleChanges
allocateCollectorService.updateCollectorScheduleChanges = data => {
  return fetchV2({
    url: `${env.API_MSP}/collector/collector-schedule-changes/${data.id}`,
    method: "put",
    data,
  });
};

// deleteCollectorScheduleChanges
allocateCollectorService.deleteCollectorScheduleChanges = data => {
  return fetchV2({
    url: `${env.API_MSP}/collector/collector-schedule-changes/${data.id}`,
    method: "delete",
  });
};

// clearCollectorScheduleChanges
allocateCollectorService.clearCollectorScheduleChanges = hubId => {
  return fetchV2({
    url: `${env.API_MSP}/collector/collector-schedules/clear-data/${hubId}`,
    method: "delete",
  });
};

allocateCollectorService.changeCollectorType = () => {
  return fetchV2({
    url: `${env.API_MSP}/collector/collector-schedule-changes/change-collector-type`,
    method: "get",
    params: {
      // ...columnFilter,
      // page: params.page || 1,
      // "per-page": params.sizePerPage || 10,
      // keywords: params.keywords || "",
      // expand: params.expand || "",
      // fields: params.fields || defaultFields.join(","),
    },
  });
};

allocateCollectorService.listCollectorFree = ({ params }) => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/list-collector-free`,
    method: "get",
    params: {
      date: params.date,
      timeslot_ids: params.timeslot_ids,
      type: params.type,
      hub_id: params.hub_id,
    },
  });
};

allocateCollectorService.listCollectorCurrent = ({ params }) => {
  return fetchV2({
    url: `${env.API_MSP}/ajax/list-collector-current`,
    method: "get",
    params: {
      date: params.date,
      timeslot_ids: params.timeslot_ids,
      type: params.type,
      hub_id: params.hub_id,
    },
  });
};

export default allocateCollectorService;
